  const blufilter_name=["BluFlow 1011","BluFlow 2011","BluFlow 3611","BluFlow 5211"];
  const blufilter_cap=[1000,2000,3600,5200];
  const blufilter_img=["https://cdn.shopify.com/s/files/1/0434/9142/6470/products/BluFilter1011-2011Vooraanzicht_110x110@2x.jpg?v=1639401287","https://cdn.shopify.com/s/files/1/0434/9142/6470/products/BluFilter1011-2011Vooraanzicht_110x110@2x.jpg?v=1639401287","https://cdn.shopify.com/s/files/1/0434/9142/6470/products/BluFilter3611-5211Vooraanzicht_110x110@2x.jpg?v=1639402202","https://cdn.shopify.com/s/files/1/0434/9142/6470/products/BluFilter3611-5211Vooraanzicht_110x110@2x.jpg?v=1639402202"];
  const blufilter_url=["https://www.blugarda.nl/products/blufilter-1011-vijverfilterset-met-uv-c","https://www.blugarda.nl/products/blufilter-2011-vijverfilterset-met-uv-c","https://www.blugarda.nl/products/blufilter-3611-vijverfilterset-met-uv-c","https://www.blugarda.nl/products/blufilter-5211-vijverfilterset-met-uv-c"];
  const factor_norm =2;
  const factor_vissen=0.75;
  const factor_planten=2;
  
  
  function calc_factor(vissen,planten){
    if(vissen=="1"){
      f_vissen=factor_vissen;
    } else if(vissen==0){
      f_vissen=1;
    }
    
    if(planten=="1"){
      f_planten=factor_planten;
    } else if(planten==0) {
      f_planten=1;
    }
    
    return factor_norm*f_vissen*f_planten;
  }
  
  function calc_keuze(doorstroom){
    var n=blufilter_cap.length;
    var found=0;
    var type=999;
    for(let i = 0; i < n; i++) {
      var cap=blufilter_cap[i];
      if(found==1){
      } else {
        if(cap>=doorstroom){
          type=i;
          found=1;
        }
      }
    }
    
    return type;
  }
  
  function calc_output(){
    var vissen=$("#situatie_vissen").val();    
    var planten=$("#situatie_planten").val();
    var fact=calc_factor(vissen,planten);
    
    var inhoud=parseFloat($("#situatie_inhoud").val());
    
    if(inhoud>0 && inhoud<100000){


      if(vissen==1){
        var vissen_text="met vissen";
      } else {
        var vissen_text="zonder vissen";
      }

      if(planten==1){
        var planten_text="met planten";
      } else {
        var planten_text="zonder planten";
      }

      var doorstroom = inhoud/fact;

      var keuze = calc_keuze(doorstroom);
      var set_keuze_text;
      if(keuze==999){
        //geen keuze gevonden
        set_keuze_text="Helaas hebben we geen geschikte filtersystemen voor de behoefte van jouw vijver. Binnenkort komt onze nieuwe lijn drukfilters beschikbaar. Deze zijn ook geschikt voor de grotere vijver. Meld je aan voor onze nieuwsbrief onderaan de website en blijf op de hoogte wanneer deze beschikbaar komen.";
      } else {
        var name=blufilter_name[keuze];
        var cap=blufilter_cap[keuze];
        var img_url=blufilter_img[keuze];
        var product_url=blufilter_url[keuze];
        set_keuze_text='<h3>'+name+'</h3><img src="'+img_url+'"><br/>De <strong>'+name+'</strong> is ideaal voor je vijver met een doorstroomcapaciteit van <strong>'+cap.toString()+' liter / uur</strong>.<br/><br/><a href="'+product_url+'" class="btn">Bekijk & bestel</a>';
      }

      var doorstroom_text=(doorstroom).toFixed(0).toString();
      var fact_text=fact.toFixed(1).toString().replace(".",",");

      var set_text="Voor een vijver met een <strong>inhoud van "+inhoud.toString()+" liter</strong>, <strong>"+vissen_text+"</strong> en <strong>"+planten_text+"</strong> zal het water <strong>elke "+fact_text+" uur</strong> door je vijver moeten stromen. Je hebt dus een filter nodig met een doorstroomcapaciteit <strong>"+doorstroom_text+" liter per uur</strong> nodig.";
      $("#situatie_doorstroom").html(set_text);

      $("#situatie_keuze").html(set_keuze_text);
    }
  }
$( document ).ready(function() {

  $( "#situatie_vissen" ).change(function() {
    calc_output();
  });
  
  $( "#situatie_planten" ).change(function() {
    calc_output();
  });
  
  $( "#situatie_inhoud" ).change(function() {
    calc_output();
  });
});